import React, { createContext, useContext } from "react";
import { useAdminDashboard } from "../hooks/useAdminDashboard";

const AdminDashboardContext = createContext(null);

export const AdminDashboardProvider = ({ children }) => {
   const dashboard = useAdminDashboard();
  return (
    <AdminDashboardContext.Provider value={dashboard}>
      {children}
    </AdminDashboardContext.Provider>
  );
};

export const useAdminDashboardContext = () => {
  const ctx = useContext(AdminDashboardContext);
  if (!ctx) throw new Error("useAdminDashboardContext must be used inside AdminDashboardProvider");
  return ctx;
};
